import React from 'react';
import cn from 'classnames';
import { Icon } from '@landing/ui';
import { PHONE, EMAIL } from 'define';
import { cleanPhoneNumber } from 'utils';

import * as styles from './Contacts.module.scss';

function Contacts({ className, theme }) {
  return (
    <div className={cn(className, styles.wrapper, theme && styles[theme])}>
      {PHONE && (
        <a href={`tel:${cleanPhoneNumber(PHONE)}`} className={styles.contact}>
          <Icon name="phone" className={styles.icon} />
          <span className={styles.contactText}>{PHONE}</span>
        </a>
      )}
      <a href={`mailto:${EMAIL}`} className={styles.contact}>
        <Icon name="email" className={styles.icon} />
        <span className={styles.contactText}>{EMAIL}</span>
      </a>
    </div>
  );
}

export default Contacts;
